import _slicedToArray from "/home/keoadmin/agent/_work/117/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";
import { useEffect, useMemo, useRef, useState } from "react";
import { StringParam } from "serialize-query-params";
import { decodedParamCache } from "./decodedParamCache";
import { extendParamConfigForKeys, convertInheritedParamStringsToParams } from "./inheritedParams";
import { makeStableGetLatestDecodedValues } from "./latestValues";
import { memoSearchStringToObject } from "./memoSearchStringToObject";
import { mergeOptions } from "./options";
import { useQueryParamContext } from "./QueryParamProvider";
import { enqueueUpdate } from "./updateSearchString";
import { serializeUrlNameMap } from "./urlName";
function useQueryParams(arg1, arg2) {
  var _useQueryParamContext = useQueryParamContext(),
    adapter = _useQueryParamContext.adapter,
    contextOptions = _useQueryParamContext.options;
  var _useState = useState(makeStableGetLatestDecodedValues),
    _useState2 = _slicedToArray(_useState, 1),
    stableGetLatest = _useState2[0];
  var _parseArguments = parseArguments(arg1, arg2),
    paramConfigMapWithInherit = _parseArguments.paramConfigMap,
    options = _parseArguments.options;
  var mergedOptions = useMemo(function () {
    return mergeOptions(contextOptions, options);
  }, [contextOptions, options]);
  var paramConfigMap = convertInheritedParamStringsToParams(paramConfigMapWithInherit, mergedOptions);
  var parsedParams = memoSearchStringToObject(mergedOptions.searchStringToObject, adapter.location.search, serializeUrlNameMap(paramConfigMap));
  if (mergedOptions.includeAllParams) {
    paramConfigMap = extendParamConfigForKeys(paramConfigMap, Object.keys(parsedParams), mergedOptions.params, StringParam);
  }
  var decodedValues = stableGetLatest(parsedParams, paramConfigMap, decodedParamCache);
  var paramKeyString = Object.keys(paramConfigMap).join("\0");
  useEffect(function () {
    var paramNames = paramKeyString.split("\0");
    decodedParamCache.registerParams(paramNames);
    return function () {
      decodedParamCache.unregisterParams(paramNames);
    };
  }, [paramKeyString]);
  var callbackDependencies = {
    adapter: adapter,
    paramConfigMap: paramConfigMap,
    options: mergedOptions
  };
  var callbackDependenciesRef = useRef(callbackDependencies);
  if (callbackDependenciesRef.current == null) {
    callbackDependenciesRef.current = callbackDependencies;
  }
  useEffect(function () {
    callbackDependenciesRef.current.adapter = adapter;
    callbackDependenciesRef.current.paramConfigMap = paramConfigMap;
    callbackDependenciesRef.current.options = mergedOptions;
  }, [adapter, paramConfigMap, mergedOptions]);
  var _useState3 = useState(function () {
      var setQuery2 = function setQuery2(changes, updateType) {
        var _callbackDependencies = callbackDependenciesRef.current,
          adapter2 = _callbackDependencies.adapter,
          paramConfigMap2 = _callbackDependencies.paramConfigMap,
          options2 = _callbackDependencies.options;
        if (updateType == null) updateType = options2.updateType;
        enqueueUpdate({
          changes: changes,
          updateType: updateType,
          currentSearchString: adapter2.location.search,
          paramConfigMap: paramConfigMap2,
          options: options2,
          adapter: adapter2
        }, {
          immediate: !options2.enableBatching
        });
      };
      return setQuery2;
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    setQuery = _useState4[0];
  return [decodedValues, setQuery];
}
var useQueryParams_default = useQueryParams;
function parseArguments(arg1, arg2) {
  var paramConfigMap;
  var options;
  if (arg1 === void 0) {
    paramConfigMap = {};
    options = arg2;
  } else if (Array.isArray(arg1)) {
    paramConfigMap = Object.fromEntries(arg1.map(function (key) {
      return [key, "inherit"];
    }));
    options = arg2;
  } else {
    paramConfigMap = arg1;
    options = arg2;
  }
  return {
    paramConfigMap: paramConfigMap,
    options: options
  };
}
export { useQueryParams_default as default, useQueryParams };